import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-deprecated-monitor-warning-banner',
  templateUrl: './deprecated-monitor-warning-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// TODO: remove this component after 28.02.2025 #16015
export class DeprecatedMonitorWarningBannerComponent {}
